import { createFileRoute, redirect } from '@tanstack/react-router';
import { Flush } from '@/contexts/fullbleed';
import { TeamChatWorkspace } from '@/components/team-chat/TeamChatWorkspace';
import { useAuthStore } from '@/stores/auth.store';

type TeamChatSearch = { conversationId?: string };

// Notifications for general team chats link here with ?conversationId=, so the
// search param is the single source of truth for which chat is open.
export const Route = createFileRoute('/_dashboard/dashboard/team-chat')({
  validateSearch: (search: Record<string, unknown>): TeamChatSearch => ({
    ...(typeof search.conversationId === 'string' ? { conversationId: search.conversationId } : {}),
  }),
  beforeLoad: () => {
    const { permissions } = useAuthStore.getState();
    if (permissions.length && !permissions.includes('internal_messages:view')) {
      throw redirect({ to: '/dashboard/home' });
    }
  },
  component: TeamChatPage,
});

function TeamChatPage() {
  const { conversationId } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <>
      <Flush />
      <TeamChatWorkspace
        conversationId={conversationId}
        onSelect={(id) =>
          void navigate({ search: id ? { conversationId: id } : {}, replace: Boolean(!id) })
        }
      />
    </>
  );
}
